const reorderImageWithTextInMobile = () => {
	const mediaQuery = window.matchMedia("(max-width: 767px)")

	if (mediaQuery.matches) {

		const reorderImageWithTextSections = document.querySelectorAll('.brick__section.brick--2.brick--reorderMobile')

		if (reorderImageWithTextSections) {
			reorderImageWithTextSections.forEach(section => {
				const textNode = section.querySelector('.text__standard')
				const referenceNode = textNode.querySelector('.standard__cta')
				const imageBlock = section.querySelector('.brick__block__image ').parentNode

				if (textNode && referenceNode && imageBlock) {
					textNode.insertBefore(imageBlock, referenceNode)
				}

			})
		}

	}
}

reorderImageWithTextInMobile()
